var AsyncState;
(function (AsyncState) {
    AsyncState[AsyncState["Initial"] = 0] = "Initial";
    AsyncState[AsyncState["Pending"] = 1] = "Pending";
    AsyncState[AsyncState["Done"] = 2] = "Done";
    AsyncState[AsyncState["Error"] = 3] = "Error";
})(AsyncState || (AsyncState = {}));
var HTTPStatus;
(function (HTTPStatus) {
    HTTPStatus["Unauthorized"] = "UNAUTHORIZED";
    HTTPStatus["BadRequest"] = "BAD_REQUEST";
    HTTPStatus["Forbidden"] = "FORBIDDEN";
    HTTPStatus["NotFound"] = "NOT_FOUND";
    HTTPStatus["Conflict"] = "CONFLICT";
    HTTPStatus["UnprocessableEntity"] = "UNPROCESSABLE_ENTITY";
    HTTPStatus["TooManyRequests"] = "TOO_MANY_REQUESTS";
    HTTPStatus["Unknown"] = "UNKNOWN";
})(HTTPStatus || (HTTPStatus = {}));
const responseStatusToMessage = (status) => {
    switch (status) {
        case 400:
            return HTTPStatus.BadRequest;
        case 401:
            return HTTPStatus.Unauthorized;
        case 403:
            return HTTPStatus.Forbidden;
        case 404:
            return HTTPStatus.NotFound;
        case 409:
            return HTTPStatus.Conflict;
        case 422:
            return HTTPStatus.UnprocessableEntity;
        case 429:
            return HTTPStatus.TooManyRequests;
        default:
            return HTTPStatus.Unknown;
    }
};
const buildServiceError = async (response) => {
    const jsonResponse = await response.json().catch(() => ({}));
    return new ServiceError(responseStatusToMessage(response.status), {
        code: jsonResponse.code,
        details: jsonResponse.details,
        message: jsonResponse.message,
        requestId: jsonResponse.requestId,
        validationErrors: jsonResponse.validationErrors,
    });
};
class ServiceError extends Error {
    serviceErrorResponse;
    constructor(message, serviceErrorResponse) {
        super(message);
        this.name = "ServiceError";
        this.serviceErrorResponse = serviceErrorResponse;
    }
    toString() {
        return `${this.message} - ${JSON.stringify(this.serviceErrorResponse)}`;
    }
    hasCode(code) {
        return this.serviceErrorResponse.code === code;
    }
    hasStatusAndCode(status, code) {
        return this.message === status && this.hasCode(code);
    }
    static async fromFetchResponse(response) {
        return buildServiceError(response);
    }
    assertType() {
        // This is a no-op, but it allows us to use this method in a type guard.
    }
}

export { AsyncState, HTTPStatus, ServiceError };
//# sourceMappingURL=httpUtils.js.map
